import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    rankingList: [],
    pagination: {
      page: 1,
      size: 25
    },
    totalCount: 0
  },
  mutations: {
    setList(state, payload) {
      state.rankingList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getRankingList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    createLabel(context, query) {
      return api.createLabel(query);
    },
    removeLabel(context, query) {
      return api.removeLabel(query);
    }
  }
};

appStore.registerModule('leagueInviterRanking', store);
